<ng-template
	[ngIf]="!disableQuadro && quadroCompensiGrid && quadroCompensiGrid.length > 0">
<div class="container_conteggi">
	<h5>
		<strong>Quadro compensi</strong>
	</h5>
	<div class="quadro_compensi padding-rl-15 margin-top-15">
		<p class="col-xs-3 singlecheckbox inlineformelem">
			<label class="fakelabel"></label>
		</p>
		<p class="col-xs-2 col-sm-2 singlecheckbox inlineformelem radiobutton">
			<label class="fakelabel">Min</label>
		</p>
		<p class="col-xs-2 col-sm-2 singlecheckbox inlineformelem radiobutton">
			<label class="fakelabel">Med</label>
		</p>
		<p class="col-xs-2 col-sm-2 singlecheckbox inlineformelem radiobutton">
			<label class="fakelabel">Max</label>
		</p>
		<p class="col-xs-3 col-sm-3 singlecheckbox inlineformelem radiobutton">
			<label class="fakelabel padding-left-0">Compenso</label>
		</p>
	</div>
	<ng-template ngFor let-q [ngForOf]="quadroCompensiGrid" let-iv=index>
	<div class="padding-rl-15 margin-top-15 padding-bottom-15">
		<p class="col-xs-3 col-sm-3 singlecheckbox inlineformelem">
			<input
				[checked]="q.checkedFase" id="{{q.idCheckboxFase}}"
				(change)="gstRadio(q.fase.id,$event.target.checked);"
				type="checkbox"><label for="{{q.idCheckboxFase}}" style="padding-top: 0px;"><label class="hidden-xs fakelabel">{{q.fase.tipoFase.label}}</label></label>
		</p>
		<p class="col-xs-2 col-sm-2 singlecheckbox inlineformelem radiobutton">
			<label class="fakelabel">{{q.valoreMinimo | euro}} &euro;</label> <input
				[checked]="q.checkedMin"
				[disabled]="!q.checkedFase || q.disabledMin" name="{{q.nameRadio}}"
				id="{{q.idRadioMin}}" [value]="q.valoreMinimo"
				(click)="settaImportoFase(q.fase.id,q.valoreMinimo,0,q.checkedMin)"
				type="radio"> <label for="{{q.idRadioMin}}"></label>
		</p>
		<p class="col-xs-2 col-sm-2 singlecheckbox inlineformelem radiobutton">
			<label class="fakelabel">{{q.valoreMedio | euro}} &euro;</label> <input
				[checked]="q.checkedMed"
				[disabled]="!q.checkedFase || q.disabledMed" name="{{q.nameRadio}}"
				id="{{q.idRadioMed}}" [value]="q.valoreMedio"
				(click)="settaImportoFase(q.fase.id,q.valoreMedio,1,q.checkedMed)"
				type="radio"> <label for="{{q.idRadioMed}}"></label>
		</p>
		<p class="col-xs-2 col-sm-2 singlecheckbox inlineformelem radiobutton">
			<label class="fakelabel">{{q.valoreMassimo | euro}} &euro;</label> <input
				[checked]="q.checkedMax"
				[disabled]="!q.checkedFase || q.disabledMax" name="{{q.nameRadio}}"
				id="{{q.idRadioMax}}" [value]="q.valoreMassimo"
				(click)="settaImportoFase(q.fase.id,q.valoreMassimo,2,q.checkedMax)"
				type="radio"> <label for="{{q.idRadioMax}}"></label>
		</p>
		<p class="col-xs-3 col-sm-3" textInputCurrency [(ngModel)]="q.compenso"
			[submitPending]="!q.checkedFase" [location]="'SezioneQuadroParcelle'"
			(onReturn)="disableRadio(q)"></p>

	</div>
	</ng-template>

	<div class="padding-bottom-15 padding-rl-15 margin-top-15">
		<p class="col-sm-offset-7 col-sm-2">
			<label class="padding-left-0" for="totale-parc-lbl">Importo</label>
		</p>
		<p class="col-sm-3">
			<input id="totale-parc-lbl" name="totale" class="totale form-control alignright"
				disabled="true" value="{{ricalcolaTotale()| euro}} &euro;"
				type="text">
		</p>
	</div>
</div>
</ng-template>